"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTERVIEW_TRANSFORM_FAILED = exports.AUTO_SIGN_UP_FAILED = exports.AUTO_LOGIN_FAILED = exports.AUTO_LOGIN = void 0;
var AUTO_LOGIN = 'autoLogin';
exports.AUTO_LOGIN = AUTO_LOGIN;
var AUTO_LOGIN_FAILED = 'autoLoginFailed';
exports.AUTO_LOGIN_FAILED = AUTO_LOGIN_FAILED;
var AUTO_SIGN_UP_FAILED = 'autoSignUpFailed';
exports.AUTO_SIGN_UP_FAILED = AUTO_SIGN_UP_FAILED;
var INTERVIEW_TRANSFORM_FAILED = 'interviewTransformFailed';
exports.INTERVIEW_TRANSFORM_FAILED = INTERVIEW_TRANSFORM_FAILED;